function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

class TabsElement extends HTMLElement {
  constructor() {
    super();

    this.tabs = this.querySelectorAll(".tab");
    this.contentTabs = this.querySelectorAll(".tab-content");

    this.tabs.forEach((tab) => {
      tab.addEventListener("click", this.change.bind(this));
    });

    if (this.dataset.activeTab === "true") {
      let params = new URLSearchParams(document.location.search);
      let tab = params.get("tab");

      if (!!tab) {
        this.setActiveTab(tab);
      }
    }
  }

  change(event) {
    this.resetTabs();
    this.activeTab(event.target);
  }

  setActiveTab(target) {
    console.log("setActiveTab", {
      target,
      element: document.getElementById(target),
    });
    this.resetTabs();
    document.getElementById(target).classList.add("active");
  }

  activeTab(target) {
    target.classList.add("active");
    document.getElementById(target.dataset.target).classList.add("active");
  }

  resetTabs() {
    this.tabs.forEach((tab) => {
      tab.classList.remove("active");
    });
    this.contentTabs.forEach((content) => {
      content.classList.remove("active");
    });
  }
}

customElements.define("tabs-element", TabsElement);

class HabeasDataForm extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form.habeas-data-form");
    this.submitButton = this.querySelector('button[type="submit"]');
    this.successPopup = document.querySelector("#success-contact-form");
    this.successMessage = this.querySelector(".form-submit-message");
    this.errorMessageGroup = this.querySelector(".error_message_group");
    this.isNewsletter = this.form.classList.contains("newsletter__form");

    if (this.form) {
      this.fieldInputs = [...this.form.querySelectorAll("input")];

      this.fieldInputs.forEach((input) => {
        if (this.isNewsletter) {
          input.addEventListener("change", this.inputVerification.bind(this));
        } else {
          input.addEventListener("input", this.inputVerification.bind(this));
        }
      });

      this.form.addEventListener("submit", this.submitForm.bind(this));
    }
  }

  inputVerification(event) {
    if (!event.target.validity.valid && event.target.value != "") {
      event.target.parentNode.classList.add("invalid");
      event.target.parentNode.classList.remove("valid");
      event.target.classList.add("error");
      if (event.target.dataset.error) {
        this.querySelector(`#${event.target.dataset.error}`).classList.remove(
          "no_error"
        );
      }
    } else {
      event.target.parentNode.classList.remove("invalid");
      event.target.parentNode.classList.add("valid");
      event.target.classList.remove("error");
      if (event.target.dataset.error) {
        this.querySelector(`#${event.target.dataset.error}`).classList.add(
          "no_error"
        );
      }
    }

    this.setSubmitStatus();
  }

  setSubmitStatus() {
    let noValidForm = this.fieldInputs.some((input) => {
      return input.validity.valid == false;
    });

    console.log("noValidForm", noValidForm);

    if (!noValidForm) {
      this.submitButton.removeAttribute("disabled");
    } else {
      this.submitButton.setAttribute("disabled", "true");
    }
  }

  async submitForm(e) {
    e.preventDefault();
    try {
      const formData = new FormData(this.form);

      this.form
        .querySelector('button[type="submit"]')
        .setAttribute("disabled", "true");

      const url = servicesApp.habeasData;
      const authorization = serviceAuthorization.habeasData;

      const clientIp = await fetch("https://api.ipify.org/?format=json")
        .then((response) => response.json())
        .then((data) => data);
      const body = {
        id_type: "C.C",
        id_number: this.isNewsletter ? "0" : formData.get("contact[document]"), // Evitar nulos si no existe en otro form
        email: formData.get("contact[email]"),
        ip: clientIp.ip,
        habeas_data: true,
        request_type: "SUBSCRIBE",
        text_terms: "none",
      };

      const options = {
        method: "POST",
        headers: {
          Authorization: authorization,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };
      // console.log(servicesApp.habeasData, options);
      fetch(url, options)
        .then((response) => response.json())
        .then((data) => {
          if (data.result === "Created succesfully") {
            this.submitButton.classList.remove("active");

            if (this.isNewsletter) {
              this.submitButton.removeAttribute("disabled");
            } else {
              this.submitButton.setAttribute("disabled", "true");
            }
            this.form.reset();

            if (this.dataset.sentPopup === "true") {
              this.successPopup.setAttribute("open", "");
            } else {
              this.successMessage.classList.add("succes-form-message");
            }

            if (this.dataset.closePopup) {
              setTimeout(() => {
                document.querySelector(`#${this.dataset.closePopup}`).click();

                if (this.successMessage) {
                  this.successMessage.classList.remove("succes-form-message");
                }
              }, 1500);
            }
          }
        })
        .catch((err) => {
          console.error("Habeas Data error:", err);
          // Si falla pero es newsletter, igual enviamos el formulario de shopify para no bloquear la suscripción
          if (isNewsletter) {
            this.submitButton.removeAttribute("disabled");
            this.form.submit();
          }
        });
    } catch (err) {
      console.error(err);
    }
  }
}

customElements.define("habeas-data-form", HabeasDataForm);


const DEPARTMENTS = [
  {
    name: "antioquia",
    initial: "ANT",
    coords: "6.55,-75.817",
  },
  {
    name: "atlantico",
    initial: "ATL",
    coords: "10.5854,-75.047",
  },
  {
    name: "cundinamarca",
    initial: "CUN",
    coords: "4.7713, -74.0972",
  },
];

const CITIES = [
  {
    name: "sabaneta",
    coords: "6.1509,-75.6154",
    parentInitial: "ANT",
  },
  {
    name: "rionegro",
    coords: "6.1482,-75.3781",
    parentInitial: "ANT",
  },
  {
    name: "barranquilla",
    coords: "10.9793,-74.8003",
    parentInitial: "ATL",
  },
  {
    name: "medellin",
    coords: "6.2514, -75.5723",
    parentInitial: "ANT",
  },
  {
    name: "bogota",
    coords: "4.64543, -74.0835",
    parentInitial: "CUN",
  },
];
/* Map stores */
class MapStores extends HTMLElement {
  constructor() {
    super();

    this.coordsBase = [4.71873, -73.78149];
    this.map = L.map("map").setView(this.coordsBase, 6);

    this.iconOwnStore = `<svg version="1.1" id="Layer_1" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" x="0px" y="0px"
	 width="100%" viewBox="0 0 144 144" enable-background="new 0 0 144 144" xml:space="preserve">
<path fill="transparent" opacity="1.000000" stroke="none" 
	d="
M18.000000,145.000000 
	C12.342012,145.000000 6.684024,145.000000 1.019527,145.000000 
	C1.013018,97.082199 1.013018,49.164387 1.013018,1.000000 
	C42.353901,1.000000 83.708290,1.000000 125.873352,1.218265 
	C119.991455,7.256697 113.341011,13.126181 106.596741,18.885801 
	C95.713211,28.180340 84.812454,37.456608 73.767868,46.557209 
	C72.838982,47.322598 70.207832,47.373276 69.315651,46.625214 
	C59.219093,38.159676 49.285309,29.498968 39.355015,20.836559 
	C33.262455,15.521892 27.444622,9.866196 21.083624,4.901505 
	C19.216805,3.444474 15.749980,3.122532 13.336755,3.676250 
	C12.174309,3.942975 11.135164,7.441096 11.101740,9.493253 
	C10.898219,21.988857 11.211096,34.494816 10.892451,46.985611 
	C10.771092,51.742870 12.751346,54.934322 16.154741,57.554333 
	C30.170210,68.343735 44.269535,79.024170 58.293373,89.802780 
	C68.638771,97.754158 75.213348,96.291008 84.288544,89.985748 
	C99.736015,79.253143 114.785728,67.931122 129.695190,56.457340 
	C132.245941,54.494381 134.712662,50.562057 134.751404,47.508205 
	C134.948044,32.011143 134.331589,16.503763 134.000000,1.000000 
	C137.657333,1.000000 141.314651,1.000000 144.948044,1.000000 
	C144.948044,49.000027 144.948044,97.000038 144.948044,145.000000 
	C139.243866,145.000000 133.591644,145.000000 127.134689,144.733307 
	C133.764816,141.235336 135.563843,135.290390 135.099625,127.709610 
	C134.642883,120.250893 135.054794,112.741852 134.987091,105.255775 
	C134.886047,94.081375 130.751877,91.368820 120.634483,91.064232 
	C110.827499,90.768990 101.000183,90.839828 91.191986,91.114128 
	C88.770988,91.181831 86.072807,92.196320 84.043678,93.573563 
	C74.276909,100.202629 68.307739,99.860580 59.053871,93.684044 
	C56.888966,92.239052 54.008224,91.130798 51.457191,91.131538 
	C42.036385,91.134270 32.586388,92.276833 23.203407,91.825584 
	C14.119098,91.388710 10.956911,97.640076 10.989351,104.171669 
	C11.033145,112.989105 11.125504,121.809341 10.954425,130.623672 
	C10.846560,136.181015 12.328024,140.642532 17.609684,143.286560 
	C17.942339,143.453094 17.879074,144.410522 18.000000,145.000000 
z"/>
<path fill="#FFFFFF" opacity="1.000000" stroke="none" 
	d="
M133.555847,1.000000 
	C134.331589,16.503763 134.948044,32.011143 134.751404,47.508205 
	C134.712662,50.562057 132.245941,54.494381 129.695190,56.457340 
	C114.785728,67.931122 99.736015,79.253143 84.288544,89.985748 
	C75.213348,96.291008 68.638771,97.754158 58.293373,89.802780 
	C44.269535,79.024170 30.170210,68.343735 16.154741,57.554333 
	C12.751346,54.934322 10.771092,51.742870 10.892451,46.985611 
	C11.211096,34.494816 10.898219,21.988857 11.101740,9.493253 
	C11.135164,7.441096 12.174309,3.942975 13.336755,3.676250 
	C15.749980,3.122532 19.216805,3.444474 21.083624,4.901505 
	C27.444622,9.866196 33.262455,15.521892 39.355015,20.836559 
	C49.285309,29.498968 59.219093,38.159676 69.315651,46.625214 
	C70.207832,47.373276 72.838982,47.322598 73.767868,46.557209 
	C84.812454,37.456608 95.713211,28.180340 106.596741,18.885801 
	C113.341011,13.126181 119.991455,7.256697 126.342010,1.218265 
	C128.370560,1.000000 130.741104,1.000000 133.555847,1.000000 
z"/>
<path fill="#FFFFFF" opacity="1.000000" stroke="none" 
	d="
M18.468658,145.000000 
	C17.879074,144.410522 17.942339,143.453094 17.609684,143.286560 
	C12.328024,140.642532 10.846560,136.181015 10.954425,130.623672 
	C11.125504,121.809341 11.033145,112.989105 10.989351,104.171669 
	C10.956911,97.640076 14.119098,91.388710 23.203407,91.825584 
	C32.586388,92.276833 42.036385,91.134270 51.457191,91.131538 
	C54.008224,91.130798 56.888966,92.239052 59.053871,93.684044 
	C68.307739,99.860580 74.276909,100.202629 84.043678,93.573563 
	C86.072807,92.196320 88.770988,91.181831 91.191986,91.114128 
	C101.000183,90.839828 110.827499,90.768990 120.634483,91.064232 
	C130.751877,91.368820 134.886047,94.081375 134.987091,105.255775 
	C135.054794,112.741852 134.642883,120.250893 135.099625,127.709610 
	C135.563843,135.290390 133.764816,141.235336 126.664986,144.733307 
	C90.979103,145.000000 54.958210,145.000000 18.468658,145.000000 
z"/>
</svg>
        `;

    this.iconAfiliateStore = `<svg xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 62.464 62.464">
        <g id="Glokal-azul" transform="translate(-70.68 -70.66)">
        <circle id="Elipse_238" data-name="Elipse 238" cx="31.232" cy="31.232" r="31.232" transform="translate(70.68 70.66)" fill="#002554"/>
        <g id="Grupo_1260" data-name="Grupo 1260" transform="translate(87.249 84.931)">
            <path id="Trazado_644" data-name="Trazado 644" d="M130.37,162.613a5.11,5.11,0,0,1-3.454,1.183,5.489,5.489,0,0,1-2.734-1.187l-.466-.356a.781.781,0,0,0-.478-.161l-7.386.043a2.65,2.65,0,0,0-2.1.732,3.384,3.384,0,0,0-.764,2.506V171.3a3.286,3.286,0,0,0,.764,2.444,2.65,2.65,0,0,0,2.1.732l23.4-.051a3.263,3.263,0,0,0,2.322-.7,3.35,3.35,0,0,0,.732-2.475v-5.925a3.473,3.473,0,0,0-.732-2.506,3.171,3.171,0,0,0-2.322-.732h-7.911a.75.75,0,0,0-.458.153l-.517.38h0Z" transform="translate(-112.99 -140.549)" fill="#cb9700"/>
            <path id="Trazado_645" data-name="Trazado 645" d="M127.3,118.571l-12.375-10.8a1.368,1.368,0,0,0-.932-.364.955.955,0,0,0-.7.258,1.03,1.03,0,0,0-.258.764v9.638a3.183,3.183,0,0,0,.164,1.191,1.805,1.805,0,0,0,.591.693l10.711,8.22a5.134,5.134,0,0,0,2.475,1.085,5.924,5.924,0,0,0,2.949-.932h0l11.694-8.62a1.959,1.959,0,0,0,.556-.713,3.481,3.481,0,0,0,.137-1.171v-9.638a1.13,1.13,0,0,0-.266-.8.876.876,0,0,0-.693-.282,1.368,1.368,0,0,0-.932.364l-13.123,11.106Z" transform="translate(-113.014 -107.1)" fill="#fff"/>
        </g>
        </g>
        </svg>
        `;

    this.iconMarkerOwn = L.divIcon({
      html: this.iconOwnStore,
      iconSize: [50, 50],
      iconAnchor: [15, 30],
    });

    this.iconMarkerAfiliate = L.divIcon({
      html: this.iconAfiliateStore,
      iconSize: [50, 50],
      iconAnchor: [15, 30],
    });

    this.departmentList = this.querySelector("#department");
    this.citiesList = this.querySelector("#city");
    this.citiesOptions = [];
    this.cardStores = [];

    //ejecutando metodos
    this.MakeMap(this.map);

    this.departmentList.addEventListener(
      "change",
      this.ChangeDepartment.bind(this)
    );
    this.citiesList.addEventListener("change", this.ChangeCity.bind(this));

    //BD departments objects
    //add more in lowercase without accents
    this.departments = DEPARTMENTS;
    this.cities = CITIES;
    //End BD departments & cityes objects

    //department options
    this.arrayDepartments = document.querySelectorAll(".department-option");
    this.resultDepart = {};
    this.containerDepart = document.querySelector("#department");
    //cities options
    this.arrayCities = document.querySelectorAll(".city-option");
    this.resultCities = {};
    this.containerCities = document.querySelector("#city");
    document.addEventListener("DOMContentLoaded", this.StackInit.bind(this));
    //end department options
  }

  RemoveAccents(str) {
    return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
  }

  //function to make options selector department
  StackInit(event) {
    this.cardStores = this.querySelectorAll(".store[data-depart-parent]");
    let our = this;

    our.cardStores.forEach((card) => {
      our.departments.forEach((depart) => {
        if (
          depart.name ==
          our.RemoveAccents(card.dataset.departParent.toLowerCase())
        ) {
          card.dataset.initialParent = depart.initial;
        }
      });
    });

    //add options departments
    tiendas
      .reduce((itemArr, valor) => {
        if (!itemArr.find((i) => i.department == valor.department)) {
          itemArr.push(valor);
        }
        return itemArr;
      }, [])
      .forEach((tienda) => {
        this.departmentList.innerHTML += `<option
          class="department-option"
          data-slug="${tienda.department.trim().replaceAll(" ", "-")}"
          data-department="${DEPARTMENTS.find(
          (item) => item?.name == tienda?.department?.toLowerCase()
        )?.initial
          }"
          value="${DEPARTMENTS.find(
            (item) => item?.name == tienda?.department?.toLowerCase()
          )?.coords
          }"
        >${tienda?.department}</option>`;
      });

    //reassign cities options
    this.citiesOptions = this.querySelectorAll("#city option");
    this.RenderPoints(this.cardStores);

    //remove duplicados
    let optionsSelector = document.querySelectorAll("select option.remove");

    optionsSelector.forEach((element) => {
      element.remove();
    });
  }

  RenderPoints(array) {
    array.forEach((card) => {
      let image = card.dataset.img;
      let title = card.dataset.title;
      let coord = card.dataset.coords;
      let lat = coord.split(",")[0];
      let lon = coord.split(",")[1];
      let property = card.dataset.property;
      let mark = "";
      let address = card.dataset.address;
      let text = `
        <div class="store-image-map"><img src="${image}"></div>
        <div class="store-info-map"><b>${title}</b><br/>
        ${address}
        </div>
      `;

      if (property == "Tienda Propia") {
        mark = this.iconMarkerOwn;
      } else if (property == "Distribuidor autorizado") {
        mark = this.iconMarkerAfiliate;
      }

      let marker = L.marker([lat, lon], { icon: mark }).addTo(this.map);
      marker.bindPopup(text);
    });
  }

  MakeMap(Map) {
    L.tileLayer("https://tile.openstreetmap.org/{z}/{x}/{y}.png", {
      maxZoom: 19,
      attribution:
        '&copy; <a href="http://www.openstreetmap.org/copyright">OpenStreetMap</a>',
    }).addTo(Map);
  }

  ChangeDepartment(event) {
    this.citiesList.innerHTML = `<option value="none" data-slug="none" data-department="none" data-depart-parent="NON" selected>${defaultCity}</option>`;

    var departmentSelected = event.target.selectedOptions[0].dataset.slug;

    tiendas
      .filter(
        (t) => t.department.toLowerCase() == departmentSelected.toLowerCase()
      )
      .reduce((itemArr, valor) => {
        if (!itemArr.find((i) => i.city == valor.city)) {
          itemArr.push(valor);
        }
        return itemArr;
      }, [])
      .forEach((tienda) => {
        this.citiesList.innerHTML += `<option value="${CITIES.find(
          (item) =>
            this.RemoveAccents(item?.name) ==
            this.RemoveAccents(tienda?.city?.toLowerCase())
        )?.coords
          }" data-slug="" data-depart-parent="">${tienda?.city}</option>`;
      });

    const department = this.departmentList.value;
    const latitude = department.split(",")[0];
    const longitude = department.split(",")[1];
    let newCoordBase = JSON.stringify(this.coordsBase)
      .replace("[", "")
      .replace("]", "");

    if (department.replace(" ", "") == newCoordBase) {
      //para volver al zoom por defecto con las coordenadas base
      if (latitude && longitude) {
        const latlon = new L.LatLng(latitude, longitude);
        var bounds = latlon.toBounds(500);
        this.map.panTo(latlon).fitBounds(bounds);
        this.map.setZoom(6);
      }
    } else {
      //para ir al departamento especifico
      if (latitude && longitude) {
        const latlon = new L.LatLng(latitude, longitude);
        var bounds = latlon.toBounds(500);
        this.map.panTo(latlon).fitBounds(bounds);
        this.map.setZoom(9);
      }
    }

    let departSel = event.target.selectedOptions[0].dataset.department;

    if (departSel == "NON") {
      this.citiesList.setAttribute("disabled", true);

      //mostramos todas las cards de tiendas
      this.cardStores.forEach((card) => {
        card.classList.remove("hidden");
      });
    } else {
      this.citiesList.removeAttribute("disabled");
    }

    //control card stores
    if (event.target.selectedOptions[0].dataset.department == "NON") {
      this.cardStores.forEach((store) => {
        store.classList.remove("hidden");
      });
    } else {
      this.cardStores.forEach((store) => {
        if (
          this.RemoveAccents(
            store.getAttribute("data-depart-parent").toLowerCase()
          ) !=
          this.RemoveAccents(
            event.target.selectedOptions[0].dataset.slug.toLowerCase()
          )
        ) {
          store.classList.add("hidden");
        } else {
          store.classList.remove("hidden");
        }
      });
    }
  }

  ChangeCity(event) {
    const city = this.citiesList.value;
    const latitude = city.split(",")[0];
    const longitude = city.split(",")[1];

    //para ir a la ciudad especifica
    if (latitude && longitude) {
      const latlon = new L.LatLng(latitude, longitude);
      var bounds = latlon.toBounds(500);
      this.map.panTo(latlon).fitBounds(bounds);
      this.map.setZoom(12);
    }
  }
}

customElements.define("map-stores", MapStores);


class HabeasDataRegister extends HTMLElement {
  constructor() {
    super();

    this.form = this.querySelector("form.habeas-data-register-form");
    this.fieldInputs = [...this.form.querySelectorAll("input")];
    this.submitButton = this.querySelector("button.submit");
    this.confirmPasswordInput = this.querySelector(
      "#RegisterFormConfirmPassword"
    );

    this.fieldInputs.forEach((input) => {
      input.addEventListener("input", this.inputVerification.bind(this));
    });

    this.form.addEventListener("change", this.setSubmitStatus.bind(this));
    this.form.addEventListener("keyup", this.setSubmitStatus.bind(this));
    this.submitButton.addEventListener("click", this.submitForm.bind(this));

    if (this.confirmPasswordInput) {
      this.confirmPasswordInput.addEventListener(
        "input",
        this.checkConfirmPassword.bind(this)
      );
    }
  }

  inputVerification(event) {
    if (!event.target.validity.valid && event.target.value != "") {
      event.target.parentNode.classList.add("invalid");
      event.target.parentNode.classList.remove("valid");
      event.target.classList.add("error");
    } else {
      event.target.parentNode.classList.remove("invalid");
      event.target.parentNode.classList.add("valid");
      event.target.classList.remove("error");
    }

    if (event.target.validity.tooLong) {
      event.target.parentNode.classList.add("tooLong");
    } else {
      event.target.parentNode.classList.remove("tooLong");
    }

    if (event.target.validity.tooShort) {
      event.target.parentNode.classList.add("tooShort");
    } else {
      event.target.parentNode.classList.remove("tooShort");
    }

    if (
      !event.target.validity.tooShort &&
      !event.target.validity.tooLong &&
      !event.target.validity.valid
    ) {
      event.target.parentNode.classList.remove("tooLong");
      event.target.parentNode.classList.remove("tooShort");
    }
  }

  setSubmitStatus() {
    let noValidForm = this.fieldInputs.some((input) => {
      return input.validity.valid == false || input.value === "";
    });

    if (!noValidForm) {
      // this.submitForm();
      this.submitButton.removeAttribute("disabled");
    } else {
      this.submitButton.setAttribute("disabled", "true");
    }
  }

  checkConfirmPassword(event) {
    console.log("EVENT", {
      value: event.target.value,
      pass: this.querySelector('input[name="customer[password]"]').value,
    });

    if (
      event.target.value !==
      this.querySelector('input[name="customer[password]"]').value
    ) {
      event.target.parentNode.classList.add("doesntMatch");
      event.target.parentNode.classList.add("invalid");
      event.target.parentNode.classList.remove("valid");
      event.target.classList.add("error");
    } else {
      event.target.parentNode.classList.remove("doesntMatch");
      event.target.parentNode.classList.remove("invalid");
      event.target.parentNode.classList.add("valid");
      event.target.classList.remove("error");
    }
  }

  async submitForm(event) {
    try {
      const formData = new FormData(this.form);
      // const respJsonIp = await fetch("https://ipv4.jsonip.com/");
      const respJsonIp = await fetch("https://api.ipify.org/?format=json");
      const clientIp = await respJsonIp.json();

      console.log(
        "🚀 ~ HabeasDataRegister ~ submitForm ~ clientIp:",
        clientIp
      );

      const body = {
        first_name: formData.get("customer[first_name]"),
        last_name: formData.get("customer[last_name]"),
        email: formData.get("customer[email]"),
        ip: clientIp.ip,
        habeas_data: true,
        request_type: "REGISTER",
        text_terms: "none",
      };

      console.log("🚀 ~ HabeasDataRegister ~ submitForm ~ body:", body);

      const options = {
        method: "POST",
        headers: {
          Authorization: serviceAuthorization.habeasData,
          "Content-Type": "application/json",
        },
        body: JSON.stringify(body),
      };

      fetch(servicesApp.habeasData, options)
        .then((response) => response.json())
        .then((data) => {

          if (data.result === "Created succesfully") {
            // this.submitButton.removeAttribute("disabled");
            this.form.submit();
          }
        });
    } catch (err) {
      console.error(err);
    }
  }
}

customElements.define("habeas-data-register", HabeasDataRegister);